import type { CSSProperties } from "react";
import { STORY_LAYERS } from "./story-geometry";
import styles from "./twin-story.module.css";

export function StoryParticles({ stage = 1, selected = -1, label = "The Twin’s six concentric colour layers" }: {
  stage?: number; selected?: number; label?: string;
}) {
  return <svg className={styles.particles} viewBox="0 0 1000 600" role="img" aria-label={label}>
    {STORY_LAYERS.map((layer, i) => <g key={layer.color} className={styles.particleLayer}
      style={{ opacity: selected < 0 || selected === i ? 1 : .12 }}>
      <path fill={layer.color} d={layer.held} className={styles.particlePath}
        style={{ "--shape": `path('${stage === 0 ? layer.scattered : stage === 2 ? layer.answer : layer.held}')`, "--delay": `${i * 32}ms` } as CSSProperties} />
    </g>)}
  </svg>;
}
